
import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";

import { AuthenticationService } from "../AuthenticationService";
import { addProvider, IProviderDescriptor } from '../ServiceUtil';
import { AccountingDelegate } from "./accounting.delegate";
import
{
    IElectronicCheck,
    INewEelectronicCheck,
    INewElectronicCheckComment,
    IManualCheck,
    INewManualCheck,
    INewManualCheckComment,

    IBankDeposit,
    INewBankDeposit,
    INewBankDepositCheck,
    IEmpPayrollRecord,
    INewEmpPayrollRecord,
    INewEmpPayrollRecordDetail,
    IValidatePayrolLRecord,
    IBankDepositResponse
} from "./accounting.interface";

export class AccountingService
{

    private electronicChecks: IElectronicCheck[] = null;

    private electronicChecksSubject: BehaviorSubject<IElectronicCheck[]> = new BehaviorSubject(null);
    private electronicChecksFilteredSubject: BehaviorSubject<IElectronicCheck[]> = new BehaviorSubject(null);

    public allElectronicChecks: Observable<IElectronicCheck[]> = this.electronicChecksSubject;
    public allElectronicChecksFiltered: Observable<IElectronicCheck[]> = this.electronicChecksFilteredSubject;


    private manualChecks: IManualCheck[] = null;

    private manualChecksSubject: BehaviorSubject<IManualCheck[]> = new BehaviorSubject(null);
    private manualChecksFilteredSubject: BehaviorSubject<IManualCheck[]> = new BehaviorSubject(null);

    public allManualChecks: Observable<IManualCheck[]> = this.manualChecksSubject;
    public allManualChecksFiltered: Observable<IManualCheck[]> = this.manualChecksFilteredSubject;


    private bankDeposits: IBankDeposit[] = null;

    private bankDepositsSubject: BehaviorSubject<IBankDeposit[]> = new BehaviorSubject(null);
    private bankDepositsFilteredSubject: BehaviorSubject<IBankDeposit[]> = new BehaviorSubject(null);

    public allBankDeposits: Observable<IBankDeposit[]> = this.bankDepositsSubject;
    public allBankDepositsFiltered: Observable<IBankDeposit[]> = this.bankDepositsFilteredSubject;

    private employeePayrollRecords: IEmpPayrollRecord[] = null;


    private employeePayrollRecordsSubject: BehaviorSubject<IEmpPayrollRecord[]> = new BehaviorSubject(null);
    private employeePayrollRecordsFilteredSubject: BehaviorSubject<IEmpPayrollRecord[]> = new BehaviorSubject(null);
    private payrollDetailFilteredSubject = new BehaviorSubject<any[]>([]);



    public allEmployeePayrollRecord: Observable<IEmpPayrollRecord[]> = this.employeePayrollRecordsSubject;
    public allEmployeePayrollRecordFiltered: Observable<IEmpPayrollRecord[]> = this.employeePayrollRecordsFilteredSubject;
    public payrollDetailFiltered: Observable<any[]> =this.payrollDetailFilteredSubject.asObservable();

    private selectedBankDepositId: string = "0";

    constructor(private accountingDelegate: AccountingDelegate, private authenticationService: AuthenticationService)
    {
    }


    public get bankDepositId(): string
    {
        return this.selectedBankDepositId;
    }

    public setSelectedBankDepositId(bankDepositId: string): void
    {
        this.selectedBankDepositId = bankDepositId;
    }
    public getAllElectronicChecks(year: number): void
    {

        const orgId = this.authenticationService.GetOrgId();
        var results = this.accountingDelegate.getAllElectronicChecks(orgId, year);
        results.subscribe(data =>
        {

            this.electronicChecks = data;
            this.electronicChecksSubject.next(this.electronicChecks);
            this.electronicChecksFilteredSubject.next(this.electronicChecks);
        });
    }

    public getElectronicCheckById(electronicCheckId: string): IElectronicCheck
    {
        return this.electronicChecks.find((item: IElectronicCheck) =>
            item.electronicCheckId === electronicCheckId);
    }


    public createNewElectronicCheck(electronicCheck: INewEelectronicCheck): Observable<boolean>
    {
        var result = this.accountingDelegate.createNewElectronicCheck({ ...electronicCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.electronicChecks = response;
            this.electronicChecksSubject.next(this.electronicChecks);
            this.electronicChecksFilteredSubject.next(this.electronicChecks);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public UpdateElectronicCheck(electronicCheck: INewEelectronicCheck): Observable<boolean>
    {
     
        var result = this.accountingDelegate.UpdateElectronicCheck({ ...electronicCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.electronicChecks = response;
            this.electronicChecksSubject.next(this.electronicChecks);
            this.electronicChecksFilteredSubject.next(this.electronicChecks);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public newElectronicCheckComment(electronicCheck: INewElectronicCheckComment): Observable<boolean>
    {
        var result = this.accountingDelegate.createNewElectronicCheckComment({ ...electronicCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.electronicChecks = response;
            this.electronicChecksSubject.next(this.electronicChecks);
            this.electronicChecksFilteredSubject.next(this.electronicChecks);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }



    public getAllManualChecks(year: number): void
    {

        const orgId = this.authenticationService.GetOrgId();
        var results = this.accountingDelegate.getAllManualChecks(orgId, year);
        results.subscribe(data =>
        {

            this.manualChecks = data;
            this.manualChecksSubject.next(this.manualChecks);
            this.manualChecksFilteredSubject.next(this.manualChecks);
        });
    }

    public getManualCheckById(manualCheckId: string): IManualCheck
    {
        return this.manualChecks.find((item: IManualCheck) =>
            item.electronicCheckId === manualCheckId);
    }


    public createNewManualCheck(manualCheck: INewManualCheck): Observable<boolean>
    {
        var result = this.accountingDelegate.createNewManualCheck({ ...manualCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.manualChecks = response;
            this.manualChecksSubject.next(this.manualChecks);
            this.manualChecksFilteredSubject.next(this.manualChecks);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public UpdateManualCheck(manualCheck: INewManualCheck): Observable<boolean>
    {
        var result = this.accountingDelegate.UpdateManualCheck({ ...manualCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.manualChecks = response;
            this.manualChecksSubject.next(this.manualChecks);
            this.manualChecksFilteredSubject.next(this.manualChecks);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public newManualCheckComment(manualCheck: INewManualCheckComment): Observable<boolean>
    {
        var result = this.accountingDelegate.createNewManualCheckComment({ ...manualCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.manualChecks = response;
            this.manualChecksSubject.next(this.manualChecks);
            this.manualChecksFilteredSubject.next(this.manualChecks);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public getAllBankDeposits(): void
    {
        if (this.bankDeposits !== null && this.bankDeposits.length > 0)
        {
            return;
        }
        const orgId = this.authenticationService.GetOrgId();
        var results = this.accountingDelegate.getAllBankDeposits(orgId);
        results.subscribe(data =>
        {

            this.bankDeposits = data;
            this.bankDepositsSubject.next(this.bankDeposits);
            this.bankDepositsFilteredSubject.next(this.bankDeposits);
        });
    }

    public getBankDepositById(bankDepositId: string): IBankDeposit
    {
        return this.bankDeposits.find((item: IBankDeposit) =>
            item.bankDepositId === bankDepositId);
    }

    public getPayrollRecordById(payrolLRecordId: string): IEmpPayrollRecord
    {
        return this.employeePayrollRecords.find((item: IEmpPayrollRecord) =>
            item.employeePayrollRecordId === payrolLRecordId);
    }

    public createNewBankDeposit(bankDeposit: INewBankDeposit): Observable<boolean>
    {
        var result = this.accountingDelegate.createNewBankDeposit({ ...bankDeposit, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: IBankDepositResponse) =>
        {
            if (!response)
            {
                return observableOf(null);
            }
            this.selectedBankDepositId = response.bankDepositId;
            this.bankDeposits = response.bankDeposits;
            this.bankDepositsSubject.next(this.bankDeposits);
            this.bankDepositsFilteredSubject.next(this.bankDeposits);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public updateBankDeposit(bankDeposit: INewBankDeposit): Observable<boolean>
    {
        var result = this.accountingDelegate.updateBankDeposit({ ...bankDeposit, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.selectedBankDepositId = response.bankDepositId;
            this.bankDeposits = response.bankDeposits;
            this.bankDepositsSubject.next(this.bankDeposits);
            this.bankDepositsFilteredSubject.next(this.bankDeposits);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }
    public createNewBankDepositCheck(bankDepositCheck: INewBankDepositCheck): Observable<boolean>
    {
        bankDepositCheck.clientTimeStamp = new Date().toISOString();
        const orgId = this.authenticationService.GetOrgId();
        bankDepositCheck.orgId = orgId;
        var result = this.accountingDelegate.createNewBankDepositCheck({ ...bankDepositCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.bankDeposits = response;
            this.bankDepositsSubject.next(this.bankDeposits);
            this.bankDepositsFilteredSubject.next(this.bankDeposits);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public updateBankDepositCheck(bankDepositCheck: INewBankDepositCheck): Observable<boolean>
    {
        var result = this.accountingDelegate.updateBankDepositCheck({ ...bankDepositCheck, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.bankDeposits = response;
            this.bankDepositsSubject.next(this.bankDeposits);
            this.bankDepositsFilteredSubject.next(this.bankDeposits);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public getAllEmployeePayrollRecords(): void
    {
        if (this.employeePayrollRecords !== null && this.employeePayrollRecords.length > 0)
        {
            return;
        }
        const orgId = this.authenticationService.GetOrgId();
        var results = this.accountingDelegate.getAllEmployeePayrollRecords(orgId);
        results.subscribe(response =>
        {

            if (!response)
            {
                return observableOf(null);
            }

            this.employeePayrollRecords = response;
            this.employeePayrollRecordsSubject.next(this.employeePayrollRecords);
            this.employeePayrollRecordsFilteredSubject.next(this.employeePayrollRecords);
        });
    }


    public createNewEmployeePayrollRecord(newRecord: INewEmpPayrollRecord): Observable<boolean>
    {
        var result = this.accountingDelegate.createNewEmployeePayrollRecord({ ...newRecord, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.employeePayrollRecords = response;
            this.employeePayrollRecordsSubject.next(this.employeePayrollRecords);
            this.employeePayrollRecordsFilteredSubject.next(this.employeePayrollRecords);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public createNewEmployeePayrollRecordDetail(newRecord: INewEmpPayrollRecordDetail): Observable<boolean>
    {
        var result = this.accountingDelegate.createNewEmployeePayrollRecordDetail({ ...newRecord, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.employeePayrollRecords = response;
            this.employeePayrollRecordsSubject.next(this.employeePayrollRecords);
            this.employeePayrollRecordsFilteredSubject.next(this.employeePayrollRecords);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public processEmployeePaystubs(payrollRecordId: string): Observable<number>
    {
        var result = this.accountingDelegate.processEmployeePaystubs(this.authenticationService.getBaseRequest.orgId, payrollRecordId, this.authenticationService.getBaseRequest.userName);
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(0);
            }

            return observableOf(response.data.PendingToProcess);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public validatePayrolLRecord(newRecord: IValidatePayrolLRecord): Observable<boolean>
    {
        newRecord.clientTimeStamp = new Date().toISOString();
        const orgId = this.authenticationService.GetOrgId();
        newRecord.orgId = orgId;
        var result = this.accountingDelegate.validatePayrolLRecord({ ...newRecord, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.employeePayrollRecords = response;
            this.employeePayrollRecordsSubject.next(this.employeePayrollRecords);
            this.employeePayrollRecordsFilteredSubject.next(this.employeePayrollRecords);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }


    public loadPayrolLRecord(newRecord: IValidatePayrolLRecord): Observable<boolean>
    {
        var result = this.accountingDelegate.loadPayrolLRecords({ ...newRecord, ...this.authenticationService.getBaseRequest });
        return result.pipe(mergeMap((response: any) =>
        {
            if (!response)
            {
                return observableOf(null);
            }

            this.employeePayrollRecords = response;
            this.employeePayrollRecordsSubject.next(this.employeePayrollRecords);
            this.employeePayrollRecordsFilteredSubject.next(this.employeePayrollRecords);
            return observableOf(true);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public setPayrollDetailData(data: any[]): void { this.payrollDetailFilteredSubject.next(data);}
}